/**
 * Header Drawer Level 3 Navigation
 * Handles inline expansion of level 3 menu items
 * Following Dawn theme JavaScript patterns
 */

class HeaderDrawerLevel3 {
  constructor() {
    this.selectors = {
      level2Header: '[data-level3-toggle]',
      level2Link: '.menu-drawer__level2-header a',
      level3Container: '.menu-drawer__level2-with-children',
      expandedClass: 'level3-expanded'
    };
    
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Debug: Check if elements exist
    const headers = document.querySelectorAll(this.selectors.level2Header);
    
    console.log('Level 3 Navigation: Found', headers.length, 'headers');
    
    // Handle level 2 header clicks for toggle
    headers.forEach(header => {
      header.addEventListener('click', this.handleLevel2HeaderClick.bind(this));
    });
  }

  handleLevel2HeaderClick(event) {
    console.log('Level 2 header clicked');
    event.preventDefault();
    
    const container = event.currentTarget.closest(this.selectors.level3Container);
    if (!container) {
      return;
    }

    requestAnimationFrame(() => {
      console.log('Toggled class, expanded:', container.classList.contains(this.selectors.expandedClass));
      
      // Update ARIA attributes for accessibility
      const indicator = container.querySelector('.menu-drawer__level3-indicator');
      if (indicator) {
        const isExpanded = container.classList.contains(this.selectors.expandedClass);
        indicator.setAttribute('aria-expanded', isExpanded);
      }
    });
  }
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeaderDrawerLevel3();
  });
} else {
  new HeaderDrawerLevel3();
}